import { ExpensePaymentStatus } from '@/features/dashboard/expenses/types/ExpensePaymentStatus.ts';
import { StatusTone } from '@/components/ui/statusTone.ts';
import { PlannedTransactionPaymentStatus } from '@/features/public/bookingSummary/types/PlannedTransactionPaymentStatus.ts';
import {
  PLANNED_TRANSACTION_PAYMENT_STATUS_LABELS,
  PLANNED_TRANSACTION_PAYMENT_STATUS_TONE,
} from '@/features/public/bookingSummary/types/PlannedTransactionPaymentStatus.utils.ts';

/**
 * Kolumna statusu w tabeli wydatków jest budowana z rejestru enumów tabeli pod
 * nazwą `PlannedTransactionPaymentStatus`, więc modal i menu wiersza muszą
 * czerpać z tych samych map — inaczej ten sam stan nazywa się w tabeli inaczej
 * niż w szczegółach. Ta mapa jest jedynym miejscem, w którym oba enumy się
 * spotykają, i przestanie się kompilować, gdy któryś z nich urośnie.
 */
const PLANNED_EQUIVALENT: Record<
  ExpensePaymentStatus,
  PlannedTransactionPaymentStatus
> = {
  [ExpensePaymentStatus.AWAITING_PAYMENT]:
    PlannedTransactionPaymentStatus.AWAITING_PAYMENT,
  [ExpensePaymentStatus.PAID]: PlannedTransactionPaymentStatus.PAID,
  [ExpensePaymentStatus.OVERDUE]: PlannedTransactionPaymentStatus.OVERDUE,
  [ExpensePaymentStatus.CANCELLED]: PlannedTransactionPaymentStatus.CANCELLED,
};

export const getExpensePaymentStatusLabel = (status: string): string => {
  const planned = PLANNED_EQUIVALENT[status as ExpensePaymentStatus];

  return planned ? PLANNED_TRANSACTION_PAYMENT_STATUS_LABELS[planned] : status;
};

export const getExpensePaymentStatusTone = (status: string): StatusTone => {
  const planned = PLANNED_EQUIVALENT[status as ExpensePaymentStatus];

  return planned ? PLANNED_TRANSACTION_PAYMENT_STATUS_TONE[planned] : 'neutral';
};
